import { memo, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useDeleteCourse } from "../../hooks/query/useDeleteCourse";

interface WarningDeleteCoursePopupProps {
    courseId: number | null;
    onClose: () => void;
    onCancel: () => void;
    onSuccess: () => void;
}

function WarningDeleteCoursePopup({
    courseId,
    onClose,
    onCancel,
    onSuccess,
}: WarningDeleteCoursePopupProps) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        setTimeout(() => setShow(true), 10);
    }, []);

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            setShow(false);
            setTimeout(onClose, 300);
        }
    };
    const { mutate: deleteCourse } = useDeleteCourse();

    const handleDelete = async () => {
        if (!courseId) return;
        deleteCourse(courseId, {
            onSuccess: () => {
                setShow(false);
                setTimeout(() => {
                    onSuccess();
                    onClose();
                }, 300);
                toast.success("Xóa khóa học thành công!");
            },
            onError: () => {
                toast.error("Xóa khóa học thất bại!");
            }
        });
    };

    return (
        <div
            className="fixed inset-0 bg-[rgba(0,0,0,0.5)] z-50 flex justify-center items-center transition-opacity duration-300"
            onClick={handleOverlayClick}
            style={{ opacity: show ? 1 : 0 }}
        >
            <div
                className={`relative w-[90%] lg:w-[400px] bg-white p-[20px] rounded-box transform transition-all duration-300
                ${show ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0"}`}
            >
                <h2 className="text-secondary font-bold text-[20px] mt-[20px] text-center">
                    Bạn có chắc chắn muốn xóa khóa học này?
                </h2>

                <p className="text-center text-gray-500 mt-2">
                    Hành động này không thể hoàn tác
                </p>

                <div className="flex justify-center mt-[40px]">
                    <button
                        onClick={handleDelete}
                        className="bg-red-500 text-white px-[15px] py-[8px] rounded-[5px] min-w-[100px] hover:bg-red-600"
                    >
                        Xóa
                    </button>

                    <button
                        onClick={onCancel}
                        className="ml-[20px] bg-secondary opacity-90 hover:opacity-100 text-white px-[15px] py-[8px] rounded-[5px] min-w-[100px]"
                    >
                        Hủy
                    </button>
                </div>
            </div>
        </div>
    );
}

export default memo(WarningDeleteCoursePopup);
